import { Banner } from "@simplicity/ui";

/**
 * Thin re-export over the shared `<Banner>` primitive, so existing consumers under
 * `components/config/` keep importing `FormBanner` while the styling lives in
 * `packages/ui/src/components/banner.tsx` (SIM-1370). New code should import `Banner` from
 * `@simplicity/ui` directly; this shim goes once the remaining consumers are migrated.
 */
export function FormBanner({
  type,
  message,
  onDismiss,
}: {
  type: "success" | "error";
  message: string;
  onDismiss: () => void;
}) {
  return (
    <Banner variant={type} onDismiss={onDismiss} className="mb-4">
      {message}
    </Banner>
  );
}
